<!-- The application's navbar containing app wide navigation and menus -->
<nav class="navbar" role="navigation" aria-label="main navigation" #navbar>
  <div class="navbar-brand">
    <a class="navbar-item"  (click)="goHome()">
      <img ngSrc="../assets/svg/ams_dashboard_long.svg" height="28" width="296" alt="AMS Dashboard Logo" priority>
      <div class="dashboard-version">
        v{{dashboardVersion}}
      </div>
    </a>

    <a role="button" class="navbar-burger" [ngClass]="{'is-active': isHamburgerOpen}" (click)="toggleHamburgerMenu()" aria-label="menu" aria-expanded="false" data-target="startNavigation">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="startNavigation" class="navbar-menu" [ngClass]="{'is-active': isHamburgerOpen}">
    <div class="navbar-start">
      @if (userIsSCapi() && !userIsCustomer()) {
        <a class="navbar-item" [ngClass]="{'underline': activeMenuItem === 'scapi'}" (click)="setActiveMenuItem('scapi')">
          SCapi
        </a>
      }

      @if (userRoles.indexOf('admin') !== -1) {
        <a (click)="setActiveMenuItem('administration')" class="navbar-item" [ngClass]="{'underline': activeMenuItem === 'administration'}">
          Administration
        </a>
      }

      @if (userIsCustomer()) {
        <a (click)="setActiveMenuItem('customerDashboard')" class="navbar-item" [ngClass]="{'underline': activeMenuItem === 'customerDashboard'}" i18n>
        Customer Dashboard
      </a>
      }
    </div>

    <div class="navbar-end">
      @if (states.getActiveState(); as activeState) {
        <div class="" [ngClass]="{'has-dropdown navbar-item is-hoverable': !userIsCustomer()}">
          <a class="navbar-link" [ngClass]="{'is-arrowless': userIsCustomer()}">
            <span class="icon">
              <picture style="height: 28px">
                <source srcset="assets/img/states/{{activeState.id}}.png, assets/img/states/{{activeState.id}}@2x.png 2x" type="image/png">
                <img src="assets/img/states/{{activeState.id}}.png" alt="{{activeState.name}}">
              </picture>
            </span>
            <span class="margin-left-5">{{activeState.name}}</span>
          </a>
          @if (!userIsCustomer()) {
            <div class="navbar-dropdown is-right">
              @for (state of states.getInactiveStates(); track state) {
                <a class="navbar-item" (click)="resetFeatures(); states.setActiveState(state.id)">
                  {{state.name}}
                </a>
              }
            </div>
          }
        </div>
      }

      @if (username) {
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <i-feather name="user"></i-feather>&nbsp;
            {{username}}
          </a>
          <div class="navbar-dropdown is-right">
            <a class="navbar-item" (click)="resetDashboardLayout()">
              <span class="icon">
                <i-feather name="grid"></i-feather>
              </span>
              <span i18n class="margin-left-15">Reset Layout</span>
            </a>
            <hr class="navbar-divider">
            @if (user.hasRole('management') || user.hasRole('admin')) {
              <a class="navbar-item" (click)="window.open(keyCloakUrl, '_blank')">
                <span class="icon">
                  <i-feather name="users"></i-feather>
                </span>
                <span i18n class="margin-left-15">User management</span>
              </a>
              <hr class="navbar-divider">
            }
            <a class="navbar-item" (click)="user.logout()">
              <span class="icon">
                <i-feather name="log-out"></i-feather>
              </span>
              <span i18n class="margin-left-15">Log out</span>
            </a>
          </div>
        </div>
      }

      @if (timeLeft > 0 && timeLeft < 301 && username) {
        <div class="navbar-item" title="You will be automatically logged out when inactive." i18n-title="You will be automatically logged out when inactive.">
          <i-feather name="clock"></i-feather>&nbsp;{{timeLeft | time}}
        </div>
      }

      <a class="navbar-item" href="https://eftas.de">
        <img alt="EFTAS Logo" ngSrc="assets/svg/eftas_logo.svg" height="28" width="45">
      </a>
    </div>
  </div>
</nav>

<!-- First level router outlet. Routes defined in app.routes.ts will be injected here -->
@if ((states.getActiveState() || routeNotFound())) {
  <router-outlet></router-outlet>
} @else {
  <div class="message">
    <div class="message-header">
      <ng-container i18n>Choose active state</ng-container>
    </div>
    <div class="message-body">
      <p class="margin-bottom-15" i18n>Please choose a state from the list</p>
      <div class="select is-fullwidth">
        <select [(ngModel)]="states.selectedStateId">
          @for (state of states.states; track state) {
            <option [value]="state.id">
              {{state.name}}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="is-flex is-flex-direction-row is-fullwidth is-justify-content-end">
      <div (click)="states.setActiveState(states.selectedStateId)" class="button is-primary is-inverted" i18n>Continue</div>
    </div>
  </div>
}

<!-- State chooser message popover will be shown if no state is selected at startup -->

<!-- All notifications created by use of the showNotification Subject will be displayed here -->
@if (allNotifications.length > 0) {
  <div class="message{{allNotifications[0].class ? ' ' + allNotifications[0].class : ''}}">
    <div class="message-header">
      {{allNotifications[0].title}}
      <button class="delete" aria-label="delete" (click)="closeNotification()"></button>
    </div>
    <div class="notification-messages">
      @for (notification of allNotifications; track notification) {
        <div class="message-body"
        style="word-break: break-word; white-space: pre-line;">{{notification.message}}</div>
      }
    </div>
  </div>
}
